import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from "react";
import { useForm } from "react-hook-form";
import WysiwygEditor, { SIMPLE_TOOLBAR, MARKDOWN_TOOLBAR } from "components/TextEditor/Wysiwyg";
import { render as markdownToHtml } from "helpers/markdown";
import HtmlToMarkdown from "../utilities/HtmlToMarkdown";
import FormHelperText from "./FormHelperText";
import FormSubtext from "./FormSubtext";
const Wysiwyg = ({ id, name, label, error, setValue, output, defaultValue, placeholder, subtext, minHeight, toolbar, }) => {
    const resolvedToolbar = toolbar !== null && toolbar !== void 0 ? toolbar : (output === "markdown" ? MARKDOWN_TOOLBAR : SIMPLE_TOOLBAR);
    const initialValue = defaultValue !== null && defaultValue !== void 0 ? defaultValue : placeholder;
    const { trigger } = useForm();
    useMemo(() => {
        setValue(name, initialValue);
    }, [setValue, name, initialValue]);
    // No debounce here — WysiwygEditor already debounces onChange internally
    const handleChange = useCallback((html) => {
        const content = output === "markdown" ? HtmlToMarkdown(html) : html;
        setValue(name, content, { shouldValidate: true });
        trigger(name);
    }, [name, output, setValue, trigger]);
    return (_jsxs(_Fragment, { children: [_jsx("label", { htmlFor: id, children: label }), subtext && _jsx(FormSubtext, { text: subtext }), _jsx(WysiwygEditor, { initialValue: output === "markdown" ? markdownToHtml(initialValue !== null && initialValue !== void 0 ? initialValue : "") : (initialValue !== null && initialValue !== void 0 ? initialValue : ""), onChange: handleChange, toolbar: resolvedToolbar, minHeight: minHeight }), error && _jsx(FormHelperText, { message: error.message })] }));
};
export default Wysiwyg;
